import { Box, LinearProgress, Tab, Tabs, useTheme } from "@mui/material"
import PageHeader from "../../../components/PageHeader"
import { SyntheticEvent, useState } from "react"
import Certificates from "./certificates/Certificates"
import QuarterlyReports from "./quarterly-reports/QuaterlyReports"
import AnnualReports from "./annual-reports/AnnualReports"
import { useAppSelector } from '../../../redux/store'
import { selectLoadingState } from './slice'
import { faCertificate, faFileText } from '@fortawesome/free-solid-svg-icons'

const Reports = () => {
  const loadingState = useAppSelector(selectLoadingState)

  const theme = useTheme()
  const [tabIndex, setTabIndex] = useState<number>(0)

  const pageTabs = ['Certificates', 'Quarterly Reports', 'Annual Reports']

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setTabIndex(newValue)
  }

  const TabContent = () => {
    const tabContents = [
      <Certificates />,
      <QuarterlyReports />,
      <AnnualReports />
    ]
    return tabContents[tabIndex]
  }
  
  const isLoading = Object.values(loadingState).some(state => state === 'loading')

  return <>
    <PageHeader iconName={tabIndex === 0 ? faCertificate : faFileText} headerName={pageTabs[tabIndex]} size={'26px'} />
    {
      isLoading && <LinearProgress/>
    }
    <Box sx={{ color: theme.palette.color50555b.main }} className="container reports-container">
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="flex flex-end m-b-16">
          <Tabs value={tabIndex} onChange={handleTabChange}>
            {pageTabs.length && pageTabs.map((tab, index) => <Tab key={index} label={tab} />)}
          </Tabs>
        </Box>
        <TabContent />
      </Box>
    </Box>
  </>
}

export default Reports